import React, { FC, useState } from 'react';

import { HelpTypes } from '@pharmaplan/common';

import useCampaignStepper from '../../../../hooks/Admin/Campaigns/useCampaignStepper';
import { BroadcastGroupActionType } from '../../../../helpers/Constants';
import ConfigureCampaignEmail from '../ConfigureCampaignEmail';
import CreateEditCampaign from '../CreateEditCampaign';

const steps = [CreateEditCampaign, ConfigureCampaignEmail];

interface ICampaignStepper {
  type: BroadcastGroupActionType;
}

const CampaignStepper: FC<ICampaignStepper> = ({ type }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const { formik } = useCampaignStepper(type);

  const Step = steps[currentStep];

  return (
    <Step
      userType={formik.values.userType as HelpTypes}
      key={currentStep}
      formik={formik}
      type={type}
      setCurrentStep={setCurrentStep}
    />
  );
};

export default CampaignStepper;
